import React from 'react';
import { Link } from 'react-router-dom';
import { megaMenuCategories, services } from '../data/serviceCatalog';
import { ArrowRight, ChevronRight } from 'lucide-react';

// Desktop mega menu — 6 category columns
export const ServicesMegaMenu = ({ onNavigate }) => (
  <div className="absolute left-1/2 -translate-x-1/2 top-full mt-2 w-[min(96vw,1080px)] bg-white shadow-2xl rounded-2xl border border-gray-100 overflow-hidden z-50">
    <div className="grid grid-cols-3 gap-0">
      {megaMenuCategories.map((cat) => (
        <div key={cat.id} className="p-5 border-r border-b border-gray-100 last:border-r-0">
          <div className="text-[11px] font-bold text-[#FB8500] uppercase tracking-wider mb-1">{cat.tagline}</div>
          <div className="text-sm font-bold text-[#0A2463] mb-3">{cat.label}</div>
          <ul className="space-y-1.5">
            {cat.slugs.slice(0, 5).map((slug) => {
              const s = services[slug]; if (!s) return null;
              return (
                <li key={slug}>
                  <Link
                    to={`/services/${slug}`}
                    onClick={onNavigate}
                    data-testid={`mega-menu-${slug}`}
                    className="group flex items-center gap-1.5 text-[13px] text-gray-600 hover:text-[#0A2463] transition-colors"
                  >
                    <ChevronRight size={13} className="text-[#FFB703] opacity-0 group-hover:opacity-100 transition-opacity" />
                    <span className="group-hover:font-semibold transition-all">{s.title}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </div>
    <div className="flex items-center justify-between bg-gradient-to-r from-[#0A2463] to-[#123a8f] px-5 py-3">
      <span className="text-xs text-white/80">Browse the full catalog of business services</span>
      <Link to="/services" onClick={onNavigate} data-testid="mega-menu-view-all"
        className="inline-flex items-center gap-1 text-sm font-semibold text-[#FFB703] hover:text-white transition-colors">
        View All Services <ArrowRight size={14} />
      </Link>
    </div>
  </div>
);

export default ServicesMegaMenu;
